import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { OAuthModule } from 'angular-oauth2-oidc';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { registerLocaleData } from '@angular/common';
import localeVi from '@angular/common/locales/vi';

import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { AesCoreModule } from '@aes/core';
import { ArtstuffAclModule } from '@aes/acl';

import { AuthModule } from './auth';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout';
import { ArtSturffAppRoutingModule } from './app-routing.module';
import { fuseConfig } from './fuse-config';

import { PagesModule } from './pages';
import { CustomMatPaginatorIntl } from './custom-mat-paginator';
import { HrmModule } from './hrm';
import { SaleModule } from './sale';
import { HomedModule } from './home';

const appRoutes: Routes = [];

const CORE_MODULES = [
  BrowserModule,
  BrowserAnimationsModule,
  HttpClientModule,
  OAuthModule.forRoot(),
  RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' }),
  TranslateModule.forRoot(),
];

const FUSE_MODULES = [
  FuseModule.forRoot(fuseConfig),
  FuseSharedModule,
  ArtstuffAclModule.forRoot(),
  AesCoreModule.forRoot()
];

const APP_MODULES = [
  ArtSturffAppRoutingModule,
  AuthModule,
  HomedModule,
  HrmModule,
  SaleModule,
  LayoutModule,
  PagesModule
];

@NgModule({
  declarations: [AppComponent],
  imports: [...CORE_MODULES, ...FUSE_MODULES, ...APP_MODULES],
  providers: [
    {
      provide: MatPaginatorIntl, // using this to customize pagination labels
      useClass: CustomMatPaginatorIntl,
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB'
    }
  ],
  bootstrap: [AppComponent],
})
export class ArtSturffAppModule {
  constructor() {
    registerLocaleData(localeVi, 'vn');
  }
}
